<template>
  <div class="mobile-nav" @click="closeNav">
    <div class="menu-icon">
      <!-- 假设使用了Font Awesome的图标 -->
      <i class="iconfont icon-caidan" @click.stop="toggleNav"></i>
      <div v-if="navVisible" class="overlay"></div> <!-- 覆盖层 -->
      <a href="/" class="home-link">
        <img :src="imgSource" alt="描述性文字" style="height: 45px; width: auto; margin-left: 5px;margin-top: 20px">
      </a>
    </div>

    <transition name="slide-left">
      <div class="nav-overlay" v-if="navVisible">
        <div class="nav-content">
          <div class="horizontal-container">
            <img :src="daohangimg" alt="描述性文字" style="height: 80px; width: auto; margin-left: 0px;">
            <a href="/" class="description-text-link">
              <span class="description-text">waySway</span>
            </a>
          </div>
          <ul class="nav-items">
            <li><a href="/AboutPage">About</a></li>
            <li><a href="/ContactPage">Contact</a></li>
            <li><a href="/JoinWaitlist">Join Waitlist</a></li>
          </ul>
          <button class="join-btn">JOIN IN</button>
          <div class="footer-text">With love, from Xiamen</div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  data() {
    return {
      navVisible: false,
      imgSource: require('@/assets/shouye.png'),
      daohangimg: require('@/assets/waySwaydaohang.png')
    };

  },
  methods: {
    toggleNav(event) {
      this.navVisible = !this.navVisible;
      event.stopPropagation(); // 防止触发关闭
    },
    closeNav() {
      if (this.navVisible) {
        this.navVisible = false;
      }
    }
  },
  mounted() {
    // 监听点击事件
    document.addEventListener('click', this.closeNav);
  },
  beforeUnmount() {
    // 清理事件监听器
    document.removeEventListener('click', this.closeNav);
  }
};
</script>


<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明灰色 */
  z-index: 99; /* 确保在内容下面，导航栏上面 */
}

/* 进入动画完成的状态 */
.slide-left-enter-to {
  transform: translateX(0%);
}
/* 进入和离开激活时的状态 */
.slide-left-enter-active {
  transition: transform 0.3s ease-in-out; /* 确保时间和缓动函数一致 */
}

/* 初始进入和最终离开的状态 */
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(-100%); /* 初始进入从-100%开始 */
}

.home-link {
  text-decoration: none; /* 去除链接默认的下划线 */
  border: none; /* 确保没有边框 */
  display: inline-block; /* 防止链接占用额外空间 */
}



.horizontal-container .description-text {
  font-size: 35px; /* 增大文字的字体大小 */
  margin-left: 10px; /* 保持文本的左边距 */
  color: white; /* 维持文字颜色 */
}

.description-text-link {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的文本颜色 */
}

.horizontal-container .description-text-link .description-text {
  font-size: 35px; /* 增大文字的字体大小 */
  margin-left: 10px; /* 保持文本的左边距 */
  color: white; /* 维持文字颜色 */
}
.horizontal-container {
  display: flex;            /* 使用弹性盒模型显示元素 */
  align-items: center;      /* 垂直居中对齐容器内的所有元素 */

}
.nav-content {
  display: flex;
  flex-direction: column; /* 垂直排列子元素 */
  align-items: center; /* 子元素在交叉轴上居中对齐 */
  justify-content: center; /* 子元素在主轴上居中对齐 */
}
.menu-icon i {
  color: #fff; /* 白色 */
}
.nav-items li a, .footer-text {
  color: #fff; /* 设置链接和页脚文字为白色以确保可读性 */
}
.menu-icon i, .iconfont {
  padding: 7px; /* 提供足够的空间使图标有圆形背景 */
  margin-left: 20px; /* 向左移动，通过增加右边距 */
  font-size: 50px; /* 或者使用其他单位，如em或rem，根据需要调整大小 */
  border-radius: 50%; /* 使背景和边框为完全圆形 */
}
.iconfont.icon-caidan:hover {
  background-color: #282828;
  border: 0.5px  #282828;
  transition: all 0.3s ease-in-out;
}
/* 或者如果你想要更具体地只针对.icon-caidan图标 */
.icon-caidan {
  font-size: 30px; /* 根据你的设计需要调整 */
}
.mobile-nav .menu-icon {
  cursor: pointer;
  /* 其他样式 */
}
/* 确保过渡效果正常 */
.nav-overlay {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 100;
  transition: transform 0.5s ease-in-out; /* 平滑过渡效果 */
}
/* 当navVisible为true时，显示导航栏 */
.nav-overlay {
  background-color: #282828; /* 深灰色 */
  display: block; /* 这里保持原样，因为通过v-show控制显示/隐藏 */
  border-radius: 20px; /* 设置边框半径为20px，增大这个值可以让按钮看起来更圆 */
}

/* 可能需要调整.nav-content的样式以适应新的宽度 */
.nav-content {
  width: 100%; /* 确保内容占满.nav-overlay */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.nav-items {
  list-style: none;
  padding: 0;
  text-align: center;
  margin-bottom: 2rem; /* 增加导航项与按钮之间的间隔 */
}

.nav-items li {
  margin: 3rem 0;
}

.nav-items li a {
  text-decoration: none;
  color: #fff;
  font-size: 2rem;
}

.join-btn {
  margin-top: 1rem; /* 增加按钮与上方导航项的间隔 */
  margin-bottom: 2rem; /* 增加按钮与页脚文本之间的间隔 */
  padding: 1rem 2rem;
  font-size: 1rem;
  border-radius: 2rem;
  background-color: #00ff66; /* 绿色 */
  border: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.join-btn:hover {
  background-color: #4CAF50;
}

.footer-text {
  color: #999;
  padding: 2rem; /* 增加页脚文本的内边距，确保与按钮有足够的间隔 */
}

/* 当navVisible为true时，显示导航栏 */
.nav-overlay {
  display: block;
}
</style>
